<template>
  <div
    class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-18 mb-12 px-4"
  >
    <div>
      <p
        class="mb-6 w-fit mx-auto text-center py-2 px-4 rounded-full bg-success text-white font-bold"
      >
        {{ post.category.name }}
      </p>
      <h1
        class="text-center mx-auto max-w-6xl text-3xl lg:text-5xl font-medium mb-10"
        :class="{ 'font-matter': locale == 'vi' }"
      >
        {{ post.title }}
      </h1>
      <p class="text-lg md:text-xl text-center max-w-4xl mx-auto">
        {{ post.excerpt }}
      </p>
    </div>
    <div class="mt-24">
      <div class="max-w-3xl mx-auto">
        <img :src="post.image_url" class="w-full drop-shadow-lg rounded-xl" />
      </div>
      <div class="mx-auto mt-20 lg:flex lg:justify-center">
        <div class="hidden lg:block">
          <div class="sticky top-24">
            <div class="space-y-4 flex-col flex">
              <a
                class="inline-flex items-center justify-center w-10 h-10 transition rounded-full bg-gray-200 hover:bg-gray-300"
                :href="'https://twitter.com/intent/tweet?url=' + fullUrl"
              >
                <BrandTwitterIcon />
              </a>
              <a
                class="inline-flex items-center justify-center w-10 h-10 transition rounded-full bg-gray-200 hover:bg-gray-300"
                :href="'https://www.facebook.com/sharer.php?u=' + fullUrl"
              >
                <BrandFacebookIcon />
              </a>
              <a
                class="inline-flex items-center justify-center w-10 h-10 transition rounded-full bg-gray-200 hover:bg-gray-300"
                :href="
                  'https://www.linkedin.com/sharing/share-offsite/?url=' +
                  fullUrl
                "
              >
                <BrandLinkedinIcon />
              </a>
            </div>
          </div>
        </div>
        <div class="lg:ml-20">
          <div class="max-w-screen-md w-full mx-auto text-base sm:text-lg">
            <div class="rich-text-content" v-html="post.body"></div>
            <div class="flex mt-12">
              <p class="flex-shrink-0 mr-2 font-semibold">Tags</p>
              <div class="flex items-center flex-wrap gap-2 mb-2">
                <a
                  :href="useRoute().fullPath"
                  class="px-4 py-0.5 rounded-sm bg-gray-200"
                  v-for="tag in post.meta_keywords.split(',')"
                >
                  {{ tag }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PagesBlogRelatePosts :posts_related="posts_related" />
</template>
<script lang="ts" setup>
import moment from "moment";
import {
  BrandTwitterIcon,
  BrandLinkedinIcon,
  BrandFacebookIcon,
} from "vue-tabler-icons";
const runtimeConfig = useRuntimeConfig();
const { locale, locales } = useI18n();
const route = useRoute();
const fullUrl = computed(() => {
  var dotlocale = "";
  if (locale.value != "en") {
    dotlocale = locale.value + ".";
  }
  return "https://" + dotlocale + "qrgateway.com/" + route.fullPath;
});
const res = await useAsyncData(async () => {
  try {
    var Transform = function (post: any) {
      if (post.translations && post.translations.length) {
        for (let i = 0; i < post.translations.length; i++) {
          const element = post.translations[i];
          if (post[element.column_name]) {
            post[element.column_name] = element.value;
          }
        }
      }
      return post;
    };
    var TransformArray = function (posts: Array<any>) {
      var s = [];
      if (posts.length) {
        for (let j = 0; j < posts.length; j++) {
          const post = posts[j];
          if (post.translations && post.translations.length) {
            for (let i = 0; i < post.translations.length; i++) {
              const element = post.translations[i];
              if (post[element.column_name]) {
                post[element.column_name] = element.value;
              }
            }
          }
          s.push(post);
        }
      }
      return s;
    };
    var query = "";
    if (locale.value != "en") {
      query += "?language=" + locale.value;
    }

    var res: {
      post: {};
      posts_related: Array<any>;
      categories: Array<any>;
      slugs: Array<{
        locale: string;
        value: string;
      }>;
    } = await $fetch(
      runtimeConfig.public.app_blog_url +
        "/api/v1/posts/" +
        route.params.slug +
        query
    );

    var { post, categories, posts_related, slugs } = res;
    return {
      post: Transform(post),
      categories,
      posts_related,
      slugs: slugs,
    };
  } catch (err: any) {
    return showError({
      statusCode: 404,
      statusMessage: err.response.data.message ?? "Page Not Found",
    });
  }
});
if (!res.data.value) {
  showError({
    statusCode: 404,
    statusMessage: "Page Not Found",
  });
}
const { categories, slugs, post, posts_related } = res.data
  .value as unknown as {
  post: {
    title: string;
    image_url: string;
    excerpt: string;
    body: string;
    category: any;
    meta_keywords: string;
    created_at?: string;
    updated_at?: string;
    slug?: string;
  };
  posts_related: Array<any>;
  categories: Array<any>;
  slugs: Array<{
    locale: string;
    value: string;
  }>;
};

// seo meta

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: post.title,
  description: post.excerpt,
  url: datajd.currentURL(),
  image: post.image_url,
});
const transformLocaletoLang = (lo: string) => {
  for (let i = 0; i < locales.value.length; i++) {
    //@ts-ignore
    if (locales.value[i].code == lo) {
      //@ts-ignore
      return locales.value[i].iso;
    }
  }
  return "en-US";
};

var hiddenLink = [];
if (slugs) {
  for (let i = 0; i < slugs.length; i++) {
    const element = slugs[i] ?? slugs[0];
    let hostLocale = datajd.currentHost();
    let lang = transformLocaletoLang(element.locale);
    let dot = element.locale == "en" ? "" : element.locale + ".";
    hiddenLink.push({
      hid: "i18n-alt-" + element.locale,
      rel: "alternate",
      href: "https://" + dot + "qrgateway.com/blog/" + element.value,
      hreflang: element.locale,
    });
    hiddenLink.push({
      hid: "i18n-alt-" + lang,
      rel: "alternate",
      href: "https://" + dot + "qrgateway.com/blog/" + element.value,
      hreflang: lang,
    });
  }
  var slug = slugs.length ? slugs[0].value : post.slug;
  hiddenLink.push({
    hid: "i18n-xd",
    rel: "alternate",
    href: "https://qrgateway.com/blog/" + slug,
    hreflang: "x-default",
  });
  hiddenLink.push({
    hid: "i18n-can",
    rel: "canonical",
    href: "https://qrgateway.com/blog/" + slug,
  });
}
i18nHead.value.link = hiddenLink;
useHead({
  title: post.title,
  meta: [
    { name: "description", content: post.excerpt },
    { name: "keywords", content: post.meta_keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: post.title,
    datePublished: moment(post.created_at).toISOString(),
    dateModified: moment(post.updated_at).toISOString(),
    description: post.excerpt,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: post.image_url,
  }),
  defineArticle({
    name: post.title,
    headline: post.title,
    datePublished: moment(post.created_at).toISOString(),
    dateModified: moment(post.updated_at).toISOString(),
    description: post.excerpt,
    url: datajd.currentURL(),
    image: post.image_url,
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      { item: { name: "Blog", "@id": datajd.currentHost() + "/blog" } },
      {
        item: {
          name: post.title,
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
</script>
